module.exports = __webpack_public_path__ + "static/media/realtors-icon-14.5d56357d.svg";